export enum ViewportMode {
  mobile = "mobile",
  tablet = "tablet",
  desktop = "desktop"
}

export default ViewportMode;
